<template>
  <div>
    <v-btn-toggle>
      <v-btn @click="addClass('previewArea')"
        ><v-icon>mdi-desktop-mac</v-icon></v-btn
      >
      <v-btn @click="addClass('previewAreaSP')"
        ><v-icon>mdi-cellphone</v-icon></v-btn
      >
    </v-btn-toggle>
    <div ref="previewArea" class="text-center grey lighten-3"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PreviewLayout',
  props: {
    id: {
      type: Number,
      required: true
    },
    headContent: {
      type: String
    },
    bodyContent: {
      type: String
    },
    cssContent: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['getHtmlPageVersion']),
    htmlPageVersion () {
      return this.getHtmlPageVersion(this.id)
    }
  },
  watch: {
    id: function () {
      this.recreateIframe()
    },
    headContent: function () {
      this.recreateIframe()
    },
    bodyContent: function () {
      this.recreateIframe()
    },
    cssContent: function () {
      this.recreateIframe()
    }
  },
  mounted () {
    this.appendIframe()
  },
  methods: {
    recreateIframe () {
      let iframes = document.getElementsByTagName('iframe')
      while (iframes.length) {
        iframes.item(0).remove()
      }
      this.appendIframe()
    },
    appendIframe () {
      const iframe = document.createElement('iframe')
      iframe.classList.add('previewArea')
      this.$refs.previewArea.appendChild(iframe)
      const html = this.htmlContent()
      const iframeDocument = iframe.contentWindow.document
      iframeDocument.open()
      iframeDocument.write(html)
      iframeDocument.close()
    },
    addClass (device) {
      const iframe = this.$refs.previewArea.children[0]
      iframe.classList.remove(...iframe.classList)
      iframe.classList.add(device)
    },
    htmlContent () {
      return (
        this.headContent +
        this.bodyContent +
        '<style>' +
        this.cssContent +
        '</style>'
      )
    }
  }
}
</script>

<style>
.previewArea {
  width: 100%;
  min-height: 600px;
}

.previewAreaSP {
  width: 375px%;
  min-height: 600px;
}
</style>
